import React, { Fragment, useEffect } from "react"
import Backbar from "~/pages/NetworkProviders/BackBar";

import security from "~/services/security";


const OfferDaddyOfferWall = ({})=> {

  const currentUser = security.currentUserValue;
  const appToken    = '132081';

  useEffect(()=> {
    document.body.style.overflow = "hidden";
  }, []);

  return (
    <Fragment>
      <Backbar path="/offers" showLogo={true} />

      <iframe
        sandbox="allow-top-navigation allow-scripts allow-popups allow-forms allow-same-origin"
        style={{width:"100%", height: "92vh", margin: "0 auto", padding: 0, border: 0}}
        src={`https://www.offerdaddy.com/wall/${appToken}/${currentUser.id}/`}
      ></iframe>

    </Fragment>
  );
};

export default OfferDaddyOfferWall;
